/*
 * サブシステム名：
 * 機能名：定型コース一覧
 * 表示項目カスタマイズ(antz)
 */
import D2MSTD0450 from '@/views/MST/D2MSTD0450.js'
import filter from '@/rahmen/utils/filters'

export default {
  extends: D2MSTD0450,
  name: 'MstTeikeiCorceListCustomForAntz',
  data: () => ({
    custoMizeHeaders: [
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '得意先名称', value: 'tokuisakiDisp' },
      { text: '担当営業所', value: 'tantoEigyoshoDisp' },
      { text: '客先注文番号', value: 'chumonNo' },
      { text: '現場名', value: 'hinmeiDisp' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp', align: 'end' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速代', value: 'hiwayPrice', align: 'end' },
      { text: 'その他課税', value: 'unchinHokaKingaku', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazei', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
      { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '売上金額', value: 'uriageKingaku', align: 'end' },
      { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
      { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '傭車その他課税', value: 'yoshaUnchinHokaKingaku', align: 'end' },
      { text: '傭車その他非課税', value: 'yoshaUnchinHokaHikazei', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' }
    ]
  }),
  computed: {
    custoMizeFilteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        elem.keiyuchiId2Disp = elem.keiyuchiId2 ? elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm : elem.keiyuchiId2Biko
        elem.keiyuchiId3Disp = elem.keiyuchiId3 ? elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm : elem.keiyuchiId3Biko
        elem.keiyuchiId4Disp = elem.keiyuchiId4 ? elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm : elem.keiyuchiId4Biko
        elem.keiyuchiId5Disp = elem.keiyuchiId5 ? elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm : elem.keiyuchiId5Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.hokanKingaku) { elem.hokanKingaku = filter.numericFormatter(elem.hokanKingaku) }
        if (elem.niekiKingaku) { elem.niekiKingaku = filter.numericFormatter(elem.niekiKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.tatekaekinHikazei) { elem.tatekaekinHikazei = filter.numericFormatter(elem.tatekaekinHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) }
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + ' km' : null
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.uriageKingaku) { elem.uriageKingaku = filter.numericFormatter(elem.uriageKingaku) }
        return elem
      })
    }
  },
  methods: {
  }
}
